import { makeStyles } from '@material-ui/core/styles'
import Colors from '../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    marginTop: 24,
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
  },
  toppingCategoryContainer: {
    marginTop: 22,
  },
  toppingCategoryDescription: {
    color: Colors.SECONDARY_FONT_COLOR,
    fontSize: 13,
  },
  toppingCategoryToppingsContainer: {
    marginTop: 10,
  },
  toppingsTitle: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontSize: 17,
  },
}))
